<template>
  <el-dialog
    title="设备详情"
    :visible.sync="localVisible"
    width="740px"
    append-to-body
    @close="handleClose"
  >
    <div v-if="deviceData" class="detail-container">
      <div class="custom-desc">
        <div class="desc-row">
          <div class="desc-item">
            <div class="desc-label">设备编号</div>
            <div class="desc-value">
              <code class="highlight-code">{{ deviceData.deviceCode }}</code>
            </div>
          </div>
          <div class="desc-item">
            <div class="desc-label">累计维修次数</div>
            <div class="desc-value">{{ deviceData.repairCount || 0 }}</div>
          </div>
        </div>

        <div class="desc-row">
          <div class="desc-item">
            <div class="desc-label">设备名称</div>
            <div class="desc-value">
              <span class="device-name-text">{{ deviceData.deviceName }}</span>
            </div>
          </div>
        </div>

        <div class="desc-row">
          <div class="desc-item">
            <div class="desc-label">消防系统</div>
            <div class="desc-value">{{ deviceData.systemName }}</div>
          </div>
          <div class="desc-item">
            <div class="desc-label">设施类型</div>
            <div class="desc-value">{{ deviceData.deviceTypeName }}</div>
          </div>
        </div>

        <div class="desc-row">
          <div class="desc-item">
            <div class="desc-label">所属区域</div>
            <div class="desc-value">{{ deviceData.areaPath }}</div>
          </div>
        </div>

        <div class="desc-row">
          <div class="desc-item">
            <div class="desc-label">安装位置</div>
            <div class="desc-value">{{ deviceData.installLocation || '-' }}</div>
          </div>
        </div>

        <div class="desc-row">
          <div class="desc-item">
            <div class="desc-label">设备型号</div>
            <div class="desc-value">{{ deviceData.model || '-' }}</div>
          </div>
          <div class="desc-item">
            <div class="desc-label">生产厂家</div>
            <div class="desc-value">{{ deviceData.manufacturer || '-' }}</div>
          </div>
        </div>

        <div class="desc-row">
          <div class="desc-item">
            <div class="desc-label">设备品牌</div>
            <div class="desc-value">{{ deviceData.brand || '-' }}</div>
          </div>
        </div>

        <div class="desc-row">
          <div class="desc-item">
            <div class="desc-label">设备级别</div>
            <div class="desc-value">
              <span class="level-badge" :class="'level-' + (deviceData.deviceLevel || 'c').toLowerCase()">
                {{ deviceData.deviceLevel }}
              </span>
              <span style="margin-left: 8px; color: #606266;">{{ deviceData.deviceLevelName || deviceData.deviceLevel }}</span>
            </div>
          </div>
          <div class="desc-item">
            <div class="desc-label">设备状态</div>
            <div class="desc-value">
              <el-tag
                :type="deviceData.deviceStatus === 0 ? 'success' : 'danger'"
                size="small"
                effect="light"
              >
                {{ deviceData.deviceStatusName || (deviceData.deviceStatus === 0 ? '正常' : '故障') }}
              </el-tag>
            </div>
          </div>
        </div>

        <div class="desc-row">
          <div class="desc-item">
            <div class="desc-label">重要设备</div>
            <div class="desc-value">
              <el-tag
                v-if="deviceData.isImportant === 1"
                type="warning"
                size="small"
                effect="light"
              >
                是
              </el-tag>
              <span v-else>否</span>
            </div>
          </div>
          <div class="desc-item">
            <div class="desc-label">NFC标签</div>
            <div class="desc-value">
              <span v-if="deviceData.nfcTagId" class="nfc-status bound">
                <i class="el-icon-connection" style="margin-right: 4px;"/>{{ deviceData.nfcTagId }}
              </span>
              <span v-else class="nfc-status unbound">未绑定</span>
            </div>
          </div>
        </div>

        <div class="desc-row">
          <div class="desc-item">
            <div class="desc-label">最近检查时间</div>
            <div class="desc-value">{{ formatDateTime(deviceData.lastCheckTime) }}</div>
          </div>
          <div class="desc-item">
            <div class="desc-label">检查结果状态</div>
            <div class="desc-value">
              <template v-if="deviceData.lastCheckResult !== null && deviceData.lastCheckResult !== undefined">
                <el-tag
                  :type="deviceData.lastCheckResult === 0 ? 'success' : 'danger'"
                  size="small"
                  effect="light"
                >
                  {{ deviceData.lastCheckResult === 0 ? '正常' : '异常' }}
                </el-tag>
              </template>
              <span v-else>-</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div slot="footer">
      <el-button @click="handleClose">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { formatDateTime } from '@/features/common/utils/dateTimeUtil.js';

export default {
  name: 'DeviceDetailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    deviceData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    localVisible: {
      get () {
        return this.visible;
      },
      set (val) {
        this.$emit('update:visible', val);
      }
    }
  },
  methods: {
    handleClose () {
      this.localVisible = false;
    },
    formatDateTime
  }
};
</script>

<style scoped lang="scss">
.detail-container {
  padding: 0 4px;
}

/* 现代化描述列表核心样式 */
.custom-desc {
  border: 1px solid #ebeef5;
  border-radius: 6px;
  overflow: hidden;
  font-size: 14px;
  background: #fff;
}

.desc-row {
  display: flex;
  border-bottom: 1px solid #ebeef5;

  &:last-child {
    border-bottom: none;
  }
}

.desc-item {
  display: flex;
  flex: 1;
  border-right: 1px solid #ebeef5;

  /* 解决长文本挤压问题 */
  min-width: 0;

  &:last-child {
    border-right: none;
  }
}

.desc-label {
  width: 120px;
  background-color: #f8f9fb;
  color: #606266;
  padding: 14px 16px;
  box-sizing: border-box;
  font-weight: 500;
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.desc-value {
  flex: 1;
  padding: 14px 16px;
  color: #303133;
  box-sizing: border-box;
  word-break: break-all;
  display: flex;
  align-items: center;
}

/* 细节排版辅助 */
.highlight-code {
  color: #409eff;
  background: #ecf5ff;
  padding: 4px 8px;
  border-radius: 4px;
  font-family: monospace;
}
.device-name-text {
  font-weight: 500;
}

/* 继承原设备详情特有的徽标样式 */
.level-badge {
  width: 22px;
  height: 22px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  color: #fff;

  &.level-a { background: #f56c6c; }
  &.level-b { background: #e6a23c; }
  &.level-c { background: #b2b2b3; }
}

.nfc-status {
  font-size: 13px;
  display: flex;
  align-items: center;

  &.bound {
    color: #67c23a;
    font-weight: 500;
  }
  &.unbound {
    color: #909399;
  }
}
</style>
